import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Textarea } from "./ui/textarea";
import { Star } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export const RatingDialog = ({ ride, open, onOpenChange, onRated }) => {
  const [stars, setStars] = useState(5);
  const [comment, setComment] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [hovered, setHovered] = useState(0);

  if (!ride) return null;

  const submit = async () => {
    setSubmitting(true);
    try {
      await api.post("/passenger/rate", { ride_id: ride.id, stars, comment });
      toast.success("Thanks for the feedback");
      onOpenChange(false);
      onRated?.();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="rating-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl font-black tracking-tight">Rate your driver</DialogTitle>
          <DialogDescription>
            {ride.driver?.name || "Your driver"} · {ride.distance_km} km · £{ride.fare}
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-center justify-center gap-2 py-4" data-testid="rating-stars">
          {[1, 2, 3, 4, 5].map((n) => {
            const active = (hovered || stars) >= n;
            return (
              <button
                key={n}
                type="button"
                onMouseEnter={() => setHovered(n)}
                onMouseLeave={() => setHovered(0)}
                onClick={() => setStars(n)}
                className="p-1 transition-transform hover:scale-110"
                data-testid={`star-${n}`}
              >
                <Star
                  className={`w-10 h-10 ${active ? "fill-[#FFC107] text-[#FFC107]" : "text-muted-foreground"}`}
                  strokeWidth={1.5}
                />
              </button>
            );
          })}
        </div>

        <Textarea
          placeholder="Anything specific? (optional)"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          data-testid="rating-comment"
        />

        <div className="flex gap-2 mt-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1" data-testid="rating-skip">
            Skip
          </Button>
          <Button onClick={submit} disabled={submitting} className="flex-1" data-testid="rating-submit">
            {submitting ? "Submitting…" : "Submit"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
